<template>
  <div id="app">
    <div class="z-index-500">
      <background></background>
    </div>
    <router-view />
    <transition name="background-popup" mode="out-in">
      <loading v-if="$store.getters.loading" />
    </transition>
  </div>
</template>
<script>
import Background from "./components/Modals/Background";
import Loading from "./components/Modals/Loading";
import firebase from "./plugins/firebase";
export default {
  created() {
    if (firebase.auth().currentUser) {
      this.$store.dispatch("profile");
    }
  },
  components: {
    Loading,
    Background
  }
};
</script>